import {Action} from '@ngrx/store';
import {type} from '../utils/type';
import {CATEGORY} from '../common/category.common';

export interface IConfigurationActions {
    LOAD_CONFIGURATION: string;
    LOAD_CONFIGURATION_SUCCESS: string
    LOAD_CONFIGURATION_FAILURE: string
}

export const ActionTypes: IConfigurationActions = {
    LOAD_CONFIGURATION: type(`${CATEGORY} Load Configuration`),
    LOAD_CONFIGURATION_SUCCESS: type(`${CATEGORY} Load Configuration Success`),
    LOAD_CONFIGURATION_FAILURE: type(`${CATEGORY} Load Configuration Failure`)
};

export class LoadConfigurationAction implements Action {
    type = ActionTypes.LOAD_CONFIGURATION;
    constructor(public payload: string) {}
}

export class LoadConfigurationSuccessAction implements Action {
    type = ActionTypes.LOAD_CONFIGURATION_SUCCESS;
    constructor(public payload: any) {}
}

export class LoadConfigurationFailureAction implements Action {
    type = ActionTypes.LOAD_CONFIGURATION_FAILURE;
    payload: string = null;
}

export type Actions
    = LoadConfigurationAction
    | LoadConfigurationSuccessAction
    | LoadConfigurationFailureAction;
